import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

export const Accordion = withStyles({
  root: {
    backgroundColor: '#FAFCFE',

    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#FAFCFE',
    paddingLeft: 30,
    paddingRight: 30,
    marginTop: 30,
    minHeight: 67,
    '&$expanded': {
      minHeight: 67,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const drawerWidth = 280;

export const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#FAFCFE',
    paddingLeft: 30,
    paddingRight: 30,
  },
}))(MuiAccordionDetails);

const styles = (theme) => ({
  root: {
    width: '100%',
    padding: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: theme.typography.fontWeightRegular,
  },
  button: {
    margin: theme.spacing(1),
  },
  drawerAssets: {
    width: `calc(100% - ${drawerWidth}px)`,
  },
  drawerPaper: {
    width: `calc(100% - ${drawerWidth}px)`,
    padding: theme.spacing(3),
  },
});

export default styles;
